import { Colors } from './Colors';
import { Shape } from './Shape';
import { Button } from './Button';
import { Tag } from './Tag';
import { extendTheme } from '@chakra-ui/react';
import { Select } from './Select';
import { TextStyles } from './TextStyles';
import { LayerStyles } from './LayerStyles';
import { GlobalStyles } from './GlobalStyles';
import { MenuList } from './MenuList';
import { MenuButton } from './MenuButton';
import { Box } from './Box';
import { Breakpoints } from './Breakpoints';

export const Theme = extendTheme({
  breakpoints: Breakpoints,
  colors: Colors,
  styles: GlobalStyles,
  textStyles: TextStyles,
  layerStyles: LayerStyles,
  shape: Shape,
  components: {
    Box,
    MenuList,
    Button,
    Select,
    Tag,
    MenuButton,
  },
});
